var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.formData)?_c('PcParser',{ref:"formParser",attrs:{"form-data":_vm.formData,"need-flow":!!_vm.formData.need_flow,"module-uuid":_vm.moduleUuid,"form-mode":"add","displayData":_vm.editData,"fillData":_vm.formFillData},on:{"submit":_vm.handleSubmit,"on-cancel":_vm.handleCancel}}):_c('skeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }